import React from 'react';

import Icon from '../../../../../components/Icon';

import { ErrorFeedbackContainer } from './styles';

const ThrowMapError = ({ icon, message, color }) => (
  <ErrorFeedbackContainer color={color}>
    <Icon name={icon} />
    <p>{message}</p>
  </ErrorFeedbackContainer>
);

export default ThrowMapError;
